export function formatBytes(n: number): string {
  if (n < 1024) {
    return `${n} B`;
  }
  const units = ["KB", "MB", "GB", "TB", "PB"];
  let value = n;
  let index = -1;
  do {
    value /= 1024;
    index += 1;
  } while (value >= 1024 && index < units.length - 1);
  const digits = value < 10 ? 2 : value < 100 ? 1 : 0;
  return `${value.toFixed(digits)} ${units[index]}`;
}

const THIN_SPACE_PATTERN = /\s(?=[A-Z%]+)/;

function withThinSpace(value: string): string {
  return value.replace(THIN_SPACE_PATTERN, "\u2009");
}

export function formatBytesThin(n: number): string {
  return withThinSpace(formatBytes(n));
}
